import React from 'react'
import { Row, Col } from 'react-bootstrap';

import { Loading } from '../../components/shared'
import { commifyNumber } from '../../utils/utilities'

import featureFlags from '../../utils/featureFlags'
import ConvertibleText from '../../components/shared/ConvertibleText'

export default function ExcessPremiumGrid({ isModified, excessPremium, excessTerrorPremium, submission, manuallySetPricing, onBlurHandler }) {
  const { additional = {} } = submission.coverages.gl;
  const { terror = {} } = additional;
  return (
    <Row>
      <Col xs={8} md={6} className="excessPremiumGrid">
        <div className="premiumGrid">
          <span className="h5">Base premium</span>
          <span className="h4 base-excess-premium">{isModified ? <Loading width="23px" height="23px" /> : <ConvertibleText manuallySetPricing={manuallySetPricing}  value={{name: 'excessPremium', text: `$${commifyNumber(excessPremium || 0)}`}} onBlurHandler={onBlurHandler}/> }</span>
        </div>
        {terror.selected ? (
          <div className="premiumGrid">
            <span className="h5">TRIA</span>
            <span className="h4 tria-excess-premium">{isModified ? <Loading width="23px" height="23px" /> : <ConvertibleText manuallySetPricing={manuallySetPricing} value={{name: 'excessTerrorPremium', text: `$${commifyNumber(excessTerrorPremium || 0)}`}} onBlurHandler={onBlurHandler}/>}</span>
          </div>
          ) :
          null
        }
      </Col>
    </Row>
  )
}
